var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modals-container"},[_vm._v(" "+_vm._s(_vm.component)+" "),_c(_vm.component,_vm._b({tag:"component",on:{"close":_vm.initModal,"events":_vm.sendEvent}},'component',_vm.props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }